import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable, of } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { ICategory } from "src/app/Models/Interface/Category/category";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { ICategoryTree } from "src/app/Models/Interface/Shop/category-tree";
import { HttpParams } from "@angular/common/http";
import { ISelectCategoryTree } from "src/app/Models/Interface/Shop/select-category-tree";

@Injectable({
  providedIn: "root",
})
export class CategoryService {
  constructor(private dataService: DataService) {}

  getCategoryList(): Observable<IBaseDataList<ICategory[]>> {
    // @ts-ignore
    let categoryList: IBaseDataList<ICategory[]> = [];
    if (localStorage.getItem("categoryList")) {
      // @ts-ignore
      categoryList = JSON.parse(localStorage.getItem("categoryList")!);
      return of(categoryList);
    }
    return this.dataService.get(APIName.category.getMainCategories);
  }

  getCategoryByMainCategory(
    mainCategoryId: number
  ): Observable<ISelectCategoryTree[]> {
    let params = new HttpParams();
    params = params.append("MainCategoryId", mainCategoryId);
    return this.dataService.getWithParams(APIName.category.tree, params);
  }
}
